import { schema } from 'normalizr'

import Model from './model'
import BankAccount from './bank-account'

class Agency extends Model({
  address: undefined,
  agencyCreationDate: undefined,
  agencyCompletionPercentage: undefined,
  bankAccount: undefined,
  brandLogoPngUrl: undefined,
  cep: undefined,
  city: undefined,
  contactEmail: undefined,
  contractSocialStatute: undefined,
  cpfCnpj: undefined,
  extraAddressInfo: undefined,
  id: undefined,
  isActive: undefined,
  name: undefined,
  slug: undefined,
  nearbyLandmark: undefined,
  neighborhood: undefined,
  personResponsibleName: undefined,
  phoneNumber: undefined,
  registrationStatus: undefined,
  referaCompletionPercentage: undefined,
  responsibleRefera: undefined,
  responsibleReferaSectors: undefined,
  state: undefined,
  streetNumber: undefined,
  staffUsers: undefined,
  sendNotification: undefined,
  supportService: undefined,
  contractType: undefined,
  agencyAttachments: undefined,
  customFields: undefined,
  showReferaValue: undefined,
  pilotAutoTicket: undefined,
  vipLimit: undefined,
  flows: undefined,
  isVipAgency: undefined,
  minimumSaleValue: undefined,
  supportPhone: undefined,
  supportWhatsapp: undefined,
  supportEmail: undefined,
  defineResponsible: undefined,
  bypass: undefined,
  requireAttachmentsOnServiceorderOpening: undefined,
  enableMarketingOptIn: undefined,
  maxBypassValue: undefined,
  minBypassValue: undefined,
  reviewBudget: undefined,
  allowsRentDiscount: undefined,
  contractStatus: undefined,
  contractGenerationDate: undefined,
  contractBlockDate: undefined,
  contractSigningDate: undefined,
  sellerConnection: undefined,
  emailConfig: undefined,
  nfRequired: undefined,
  paymentMethods: undefined,
  warrantyCompensation: undefined,
  faviconUrl: undefined,
  privacyPolicyLink: undefined,
  areaOfActivity: undefined,
  score: undefined,
  acceptsCallsWithoutVisit: undefined,
  maintenanceTerm: undefined,
  maintenancesTerm: undefined,
  propertiesTerm: undefined,
  propertyTerm: undefined,
  ownerTerm: undefined,
  ownersTerm: undefined,
  tenantTerm: undefined,
  tenantsTerm: undefined,
  autoTriage: undefined,
  usePoolForWhatsapp: undefined,
  autoMessagingSaas: undefined,
  triageAis: undefined,
  areaOfActivityData: undefined,
  regime: undefined,
  referaChargeMethod: undefined,
  budgetCover: undefined,
  budgetCoverPicture: undefined,
  channelType: undefined,
  aiTextCorrection: undefined,
  aiPriceConference: undefined,
  allowsSimplifiedBudget: undefined,
  handlesInspection: undefined,
  inspectionPercentages: undefined,
  insuranceCityExceptionList: undefined,
  allowExternalServiceOrderOpening: undefined,
  useExtendedWarranty: undefined,
}) {}

const agencyNewSchema = new schema.Entity(
  'agency',
  {},
  {
    processStrategy: entity =>
      new Agency(entity).set('bankAccount', new BankAccount(entity.bankAccount)),
  }
)

const agencySchema = [agencyNewSchema]

export { agencySchema, Agency as default }
